// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'developmentCloud',
  cookieDomain:'.reach.marketing',
  //apiBaseUrl: 'http://www.savabase-dev.net/REST/WebDataService.svc',
  //cdnImagesUrl: 'http://www.savabase-dev.net/Images',
  baseUrl: 'https://reachmeapidevh.azurewebsites.net', 
  apiBaseUrl: 'https://reachmeapidevh.azurewebsites.net',
  automationsApiBaseUrl: 'https://reachmeapidevh.azurewebsites.net',
  ffmFrontendUrl:"https://dev.reach.marketing/",
  PrsprFrontendUrl:"https://dev2.reach.marketing/",
  cpjpFrontendUrl:"https://dev3.reach.marketing/",
  googleAnalyticsId: undefined
  // automationsApiBaseUrl: 'https://reachme-dev-phase2-automation-app.azurewebsites.net',
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

